import React from 'react';
import clsx from 'clsx';

export const LoadingSpinner = ({ className }: { className?: string }) => (
  <div
    className={clsx(
      'inline-block animate-spin rounded-full border-2 border-solid border-base100 border-l-neutral400',
      className,
    )}
  />
);
